import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { connect } from "react-redux";
import { setJeton } from "../../redux/actions";
import { Button, Grid } from "@mui/material";
import { PublicClientApplication } from "@azure/msal-browser";
import { config_sso } from "../../config_sso";

const msalInstance = new PublicClientApplication(config_sso);

function AuthentificationO365({ jeton, setJeton }) {
    const { accounts } = useMsal();

    const [affichercomptes, setAfficherComptes] = useState(false);

    const connecter = () =>{
        if(accounts.length===0){
            msalInstance.loginPopup(config_sso)
                .then(utilisateur => {
                    console.log(utilisateur)
                    setJeton(utilisateur.idToken);
                })
                .catch(e => {
                    console.error(e);
                });
        }
        else{
            setAfficherComptes(true);
        }
    }


    const utiliserCompteNum = (id) => {
        try {
            if (accounts.length > 0) {
                msalInstance.acquireTokenSilent({
                    account: accounts[id]
                })
                    .then(response => {
                        console.log(response)
                        setJeton(response.idToken);
                    })
                    .catch(error => {
                        msalInstance.loginPopup(config_sso)
                        .then(utilisateur => {
                            setJeton(utilisateur.idToken);
                        })
                        .catch(e => {
                            console.error(e);
                        });
                    });
            }
            else {
            }
        }
        catch (error) {
            console.log(error)
        }
    }


    return (
        <>
            {
                affichercomptes ?
                    <Grid container direction={"column"}>
                        <Grid item fontSize={'1.2rem'}>Quel compte voullez-vous utiliser ?</Grid>
                        {
                            accounts.map((utilisateur, id) => {
                                return <Button key={id} onClick={() => utiliserCompteNum(id)}>{utilisateur.username}</Button>
                            })
                        }
                    </Grid>
                    :
                    <Button variant="contained" className="ml-auto" onClick={ connecter}>Connexion par votre compte mail AGAM</Button>
            }
        </>
    );
}



function mapStateToProps(state) {
    return {
        jeton: state.jeton,
    }
}

export default connect(mapStateToProps, { setJeton })(AuthentificationO365);